export default __webpack_public_path__ + "static/media/support1.d90e4424.jpg";